function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F15A24",
  d: "M45.985 256.455L0 258.05l23.573-23.967l22.414 22.374z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M254.58 137.58c-8.543 66.613-69.475 113.676-136.077 105.123C51.889 234.158 4.826 173.228 13.37 106.62C21.919 40.008 82.838-7.06 149.457 1.494c66.61 8.542 113.684 69.478 105.124 136.084",
  fill: "#F15A24"
}), /*#__PURE__*/React.createElement("path", {
  d: "M164.982 87.532c7.99 8.494.104 28.577.104 28.577s-7.794 28.393-52.421 65.213l-8.33-8.177l56.65-57.899l1.095-1.478c1.507-2.456 2.755-26.401 2.902-26.236",
  fill: "#999"
}), /*#__PURE__*/React.createElement("path", {
  d: "M164.982 87.532c7.99 8.494.104 28.577.104 28.577s-7.794 28.393-52.421 65.213l-8.33-8.177l56.65-57.899l1.095-1.478c1.507-2.456 2.755-26.401 2.902-26.236h0z",
  stroke: "#FFF",
  strokeWidth: 1.918,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M92.1 161.108l72.763-73.785c3.693 4.385 4.479 9.11 3.407 15.842c-.722 4.663-8.775 13.981-8.775 13.981l-55.16 56",
  fill: "#666"
}), /*#__PURE__*/React.createElement("path", {
  d: "M92.1 161.108l72.763-73.785c3.693 4.385 4.479 9.11 3.407 15.842c-.722 4.663-8.775 13.981-8.775 13.981l-55.16 56",
  stroke: "#FFF",
  strokeWidth: 1.201,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M164.982 87.583L92.099 161.11l.147-.143l-.027.011l-18.083-17.818c37.708-46.905 62.089-55.65 62.089-55.65s15.872-6.196 27.195-1.388c.87.466 1.248.734 1.56 1.463",
  fill: "#FF931E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M164.982 87.583L92.099 161.11l.147-.143l-.027.011l-18.083-17.818c37.708-46.905 62.089-55.65 62.089-55.65s15.872-6.196 27.195-1.388c.87.466 1.248.734 1.56 1.463l.002-.002z",
  stroke: "#FFF",
  strokeWidth: 1.918,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M112.665 181.32c-17.388 14.32-39.641 36.816-69.889 52.506l6.728 28.762l-28.516-28.087l71.11-73.393",
  fill: "#999"
}), /*#__PURE__*/React.createElement("path", {
  d: "M112.665 181.32c-17.388 14.32-39.641 36.816-69.889 52.506l6.728 28.762l-28.516-28.087l71.11-73.393",
  stroke: "#FFF",
  strokeWidth: 1.918,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F15A24",
  d: "M74.623 143.4l17.665 17.596l-40.81 8.84l22.754-26.753l.393.318z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeWidth: 1.918,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M74.623 143.4l17.665 17.596l-40.81 8.84l22.754-26.753l.393.318z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M158.024 66.246c-1.733 15.641 9.528 29.721 25.168 31.465c15.628 1.737 29.721-9.533 31.465-25.168c1.738-15.635-9.54-29.73-25.174-31.468c-15.642-1.728-29.724 9.527-31.459 25.171",
  fill: "#999"
}), /*#__PURE__*/React.createElement("path", {
  d: "M158.024 66.246c-1.733 15.641 9.528 29.721 25.168 31.465c15.628 1.737 29.721-9.533 31.465-25.168c1.738-15.635-9.54-29.73-25.174-31.468c-15.642-1.728-29.724 9.527-31.459 25.171h0z",
  stroke: "#FFF",
  strokeWidth: 1.918,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M210.565 85.138c5.256-7.679 4.984-19.167 3.929-22.57c-1.295-4.168-4.191-10.945-9.243-14.468l-26.714 24.606s20.53 22.059 21.065 22.132c.222.026 6.17-2.698 10.963-9.7",
  fill: "#666"
}), /*#__PURE__*/React.createElement("path", {
  d: "M210.565 85.138c5.256-7.679 4.984-19.167 3.929-22.57c-1.295-4.168-4.191-10.945-9.243-14.468l-26.714 24.606s20.53 22.059 21.065 22.132c.222.026 6.17-2.698 10.963-9.7h0zm-5.39-19.275s2.569 6.307-.69 11.214l.69-11.214z",
  stroke: "#FFF",
  strokeWidth: 1.918,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#666",
  d: "M104.964 173.156l-29.482 5.247l17.796-18.49"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.964 173.156l-29.482 5.247l17.796-18.49m-17.97-16.384l37.48 35.274",
  stroke: "#FFF",
  strokeWidth: 1.918,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

function SvgGetpostmanIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    focusable: "false",
    width: "0.97em",
    height: "1em",
    style: {
      msTransform: "rotate(360deg)",
      WebkitTransform: "rotate(360deg)",
      transform: "rotate(360deg)"
    },
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 256 264",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetpostmanIcon);
export default __webpack_public_path__ + "static/media/getpostman-icon.94572c35.svg";
export { ForwardRef as ReactComponent };